
const palette = {
    primary: {
      main: "#1528d4",
      light: "#63a4ff",
      dark: "#004ba0",
    },
    secondary: {
      main: "#ffffff",
      light: "#ff79b0",
      dark: "#c60055",
    },
    success: {
      main: "#4caf50",
    },
    warning: {
      main: "#ff9800",
    },
    error: {
      main: "#f44336",
    },
    background: {
      default: "#f4f6f8",
      paper: "#ffffff",
    },
    text: {
      primary: "#212121",
      secondary: "#757575",
    },
  };
  
  export default palette;
  